import {Card, Col, Row} from 'antd';
import CampaignTabs from './campaign-tabs';
import {useBreadcrumbContext} from 'src/domain/utility/AppContextProvider/BreadcrumbContextProvider';
import {useParams} from 'react-router-dom';
import {useEffect} from 'react';
import IntlMessages from 'src/domain/utility/IntlMessages';
import MainUtils from 'src/shared/utils/main';

function CreateCampaign() {
  const {setBreadcrumb}: any = useBreadcrumbContext();
  const {id} = useParams();
  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='promotions.sideBarName' />,
        url: '/promotions/banners',
      },
      {
        text: <IntlMessages id='promotions.newsLetter' />,
        url: '/promotions/promotions.news-letter/mailing-campaigns',
      },
      {
        text: <IntlMessages id='promotions.mailingCampaigns' />,
        url: '/promotions/promotions.news-letter/mailing-campaigns',
      },
      MainUtils.isEmptyValue(id)
        ? {
            text: <IntlMessages id='campaigns.add' />,
            url: '/promotions/promotions.news-letter/mailing-campaigns/create',
          }
        : {
            text: <IntlMessages id='campaigns.edit' />,
            url: `/promotions/promotions.news-letter/mailing-campaigns/edit/${id}`,
          },
    ]);
  }, [id]);

  return (
    <Card>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <CampaignTabs />
        </Col>
      </Row>
    </Card>
  );
}

export default CreateCampaign;
